var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'vuetify/dist/vuetify.min.css';
import Navigation from '@/components/navigation/Navigation';
import { Component, Watch } from 'vue-property-decorator';
import { logGuard } from '@/router/helpers';
import { mixins } from 'vue-class-component';
import { SwUpdate } from '@/mixins/SwUpdate';
import SwUpdateAlert from '@/components/SwUpdateAlert/SwUpdateAlert.vue';
import { RolesEnum } from './items/Roles';
let App = class App extends mixins(SwUpdate) {
    constructor() {
        super(...arguments);
        this.routeName = '';
    }
    beforeCreate() {
        logGuard('[App] beforeCreate');
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        logGuard('[App] starting initialize');
        this.initializeChatSimple();
    }
    initializeChatSimple() {
        if (!this.$store.state.Auth) {
            this.removeChatScript();
            return;
        }
        if (this.$store.state.Auth.hasRole([RolesEnum.STUDENT, RolesEnum.GUARDIAN])) {
            this.removeChatScript();
            return;
        }
        const chatSimple = document.getElementById('chatsimple-widget');
        if (chatSimple) {
            chatSimple.style.display = '';
        }
        if (document.getElementById('my-chat-cdn'))
            return; // was already loaded
        var scriptTag = document.createElement("script");
        scriptTag.src = "https://cdn.chatsimple.ai/chat-bot-loader.js";
        scriptTag.id = "my-chat-cdn";
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
    }
    removeChatScript() {
        const scriptTag = document.getElementById('my-chat-cdn');
        const chatSimple = document.getElementById('chatsimple-widget');
        if (chatSimple) {
            chatSimple.style.display = 'none';
        }
        if (scriptTag) {
            scriptTag.remove();
        }
    }
    get showAppLoader() {
        logGuard('[App] this.$store.state.isLoading', this.$store.state.isLoading);
        return this.$store.state.isLoading;
    }
    get dialogOptions() {
        return this.$store.state.dialog;
    }
    get isDisplayingDialog() {
        return this.dialogOptions !== null;
    }
    set isDisplayingDialog(value) {
        this.$store.dispatch('closeDialog');
    }
    routeChanged() {
        this.initializeChatSimple();
    }
    userChanged() {
        this.initializeChatSimple();
    }
};
__decorate([
    Watch('$route', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], App.prototype, "routeChanged", null);
__decorate([
    Watch('$store.state.Auth'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], App.prototype, "userChanged", null);
App = __decorate([
    Component({
        components: {
            Navigation,
            SwUpdateAlert,
        },
    })
], App);
export default App;
